import React from 'react';
import { Field, formValueSelector } from 'redux-form';
import { Popconfirm, Icon, Row } from 'antd';
import Table from '../../../../components/generic/table/Table';
import { TableButton } from '../../../../styles/BasicStyles';
import TextInput from '../../../../components/generic/inputs/TextInput';
import NumberInput from '../../../../components/generic/inputs/NumberInput';
import BaseButton from '../../../../components/generic/buttons/BaseButton';
import { connect } from 'react-redux';

let BlueprintsTable = ({ fields, objectName, blueprints }) => {
  const columns = [
    {
      title: 'Referência',
      dataIndex: 'reference',
      render: (value, item, index) => (
        <Field
          component={TextInput}
          type="text"
          name={`${objectName}[${index}].reference`}
        />
      )
    },
    {
      title: 'Descrição',
      dataIndex: 'description',
      render: (value, item, index) => (
        <Field
          component={TextInput}
          type="text"
          name={`${objectName}[${index}].description`}
        />
      )
    },
    {
      title: 'Quantidade',
      dataIndex: 'quantity',
      render: (value, item, index) => (
        <Field
          component={NumberInput}
          name={`${objectName}[${index}].quantity`}
        />
      )
    },
    {
      title: 'Operações',
      render: (value, item, index) => (
        <React.Fragment>
          <TableButton error onClick={(e) => e.stopPropagation()}>
            <Popconfirm
              placement="topRight"
              title="Tem a certeza que quer remover a planta?"
              onConfirm={() => fields.remove(index)}
            >
              <Icon style={{ marginRight: 10 }} type="delete" />
              {'Remover'}
            </Popconfirm>
          </TableButton>
        </React.Fragment>
      )
    }
  ];

  return (
    <>
      <Row style={{ marginTop: '25px', marginBottom: '10px' }}>
        <BaseButton
          type="default"
          icon="plus"
          text="Adicionar campo"
          onClick={() => {
            if (
              blueprints.length < 4 &&
              (blueprints.length === 0 ||
                (blueprints.length > 0 && blueprints[0].reference !== ''))
            ) {
              fields.unshift({ reference: '' });
            }
          }}
        />
      </Row>
      <Row>
        <Table
          columns={columns}
          currentPage={1}
          pageSize={blueprints.length}
          loading={false}
          rows={blueprints}
          showHeader={true}
          emptyIcon="solution"
          emptyText={'Não existe nenhuma planta'}
          total={blueprints.length}
          rowKey={(record, index) => index}
        />
      </Row>
    </>
  );
};

const selector = formValueSelector('manage_events_form');

BlueprintsTable = connect((state) => {
  const { blueprints } = selector(state, 'hasFurniture', 'blueprints');
  return {
    blueprints
  };
})(BlueprintsTable);

export default BlueprintsTable;
